import ExamArrange from './src/main';

/* istanbul ignore next */
ExamArrange.install = function(Vue) {
  Vue.component(ExamArrange.name, ExamArrange);
};

export default ExamArrange;
